import { createEnumTypeGuard } from "@nvon/baseline";
import { Language } from "../../../config/LanguageConfiguration";

export const isLanguage = createEnumTypeGuard(Language);
